<div class="justup-dialog ca-cumule-dialog flex-container">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    <div class="flex-col gap-2">
      <span class="subheading-2">CA cumulé — {{ data.tiersDenomination }}</span>
      <span class="caption on-background-alt">
        {{ stats().nbPeriodes }} {{ stats().nbPeriodes > 1 ? scaleLabelPlural[scale()] : scaleLabelSingularLower[scale()] }} · {{ stats().totalFormatted }} · {{ stats().nbPeriodesAvecCA }} avec CA
      </span>
    </div>
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16 p-16">

    <div class="stats-grid flex-row gap-8 flex-wrap">
      <div class="stat-card flex-col gap-2 p-12">
        <span class="tiny on-background-alt">Total période</span>
        <span class="body-1" style="font-weight: 700">{{ stats().totalFormatted }}</span>
      </div>
      <div class="stat-card flex-col gap-2 p-12">
        <span class="tiny on-background-alt">Moyenne / {{ scaleLabelSingularLower[scale()] }}</span>
        <span class="body-1" style="font-weight: 700">{{ stats().avgFormatted }}</span>
      </div>
      <div class="stat-card flex-col gap-2 p-12"
           matTooltip="{{ scaleLabelSingularLower[scale()] }} ayant généré le plus de CA sur la période analysée">
        <span class="tiny on-background-alt">{{ scaleBestLabel[scale()] }}</span>
        <span class="body-2" style="font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
          {{ stats().bestLabel }}
        </span>
        <span class="tiny on-background-alt">{{ stats().bestCAFormatted }}</span>
      </div>
      <div class="stat-card flex-col gap-2 p-12"
           matTooltip="Nombre de {{ scaleLabelPlural[scale()] }} qui cumulent 80% du CA — plus c'est petit, plus le CA est concentré (loi de Pareto)">
        <span class="tiny on-background-alt">Pareto 80%</span>
        <span class="body-1" style="font-weight: 700">
          {{ stats().pareto80 }}<span class="caption on-background-alt"> / {{ stats().nbPeriodes }}</span>
        </span>
        <span class="tiny on-background-alt">{{ scaleLabelPlural[scale()] }} pour 80% du CA</span>
      </div>
    </div>

    <div class="flex-row gap-8 align-center">
      <span class="caption on-background-alt">Granularité</span>
      <vl-chips-toggle [elements]="scaleElements" [(value)]="scale" size="small"/>
    </div>

    <div class="data-table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th (click)="toggleSort('date')" class="sortable col-period">
              Période
              @if (sortKey() === 'date') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th (click)="toggleSort('ca')" class="sortable col-ca">
              CA
              @if (sortKey() === 'ca') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="col-part">Part</th>
            <th class="col-cumul">Cumul</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.dateKey) {
            <tr>
              <td class="col-period">
                <span class="body-2" style="font-weight: 600">{{ row.label }}</span>
              </td>
              <td class="col-ca">
                <span class="body-2" style="font-weight: 700">{{ formatEuroExact(row.ca) }}</span>
              </td>
              <td class="col-part">
                <div class="part-bar-wrap flex-row gap-6 align-center">
                  <div class="part-bar-bg">
                    <div class="part-bar-fill" [style.width.%]="partPct(row.ca)"></div>
                  </div>
                  <span class="tiny on-background-alt" style="min-width: 36px; text-align: right">
                    {{ partPct(row.ca) | number:'1.1-1':'fr-FR' }}%
                  </span>
                </div>
              </td>
              <td class="col-cumul">
                <span class="body-2" style="font-weight: 600">{{ formatEuroExact(row.cumul) }}</span>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4" style="text-align: center; padding: 24px">
                <span class="caption on-background-alt">Aucune donnée sur la période</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
